import useAxios from 'axios-hooks';

import { url } from 'constants/index';
import { ColumnIds } from 'enums';
import { buildRequestParams } from 'utils/pagination.utils';

export const useTbdCompetitors = (sportId: number) => {
  const [{ data, loading: isLoading, error }] = useAxios<PaginationData<Entity>>(
    {
      url: url.tbds,
      params: buildRequestParams({
        pageSize: 200,
        filters: [{ columnId: ColumnIds.SportId, condition: 'equals', value: sportId }],
      }),
    },
    { manual: !sportId },
  );
  return { competitors: data?.items || [], error, isLoading };
};
